module.exports = __webpack_public_path__ + "static/img/1.26a1eff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/4/1/zh/1.png
// module id = hmz9
// module chunks = 0